import React from "react";
import "./CareInstruction.css";

const CareInstruction = ({ careinstruction }) => {
  if (!careinstruction) {
    return null;
  }

  console.log("careinstruction", careinstruction);

  const {
    code,
    img,
    description,
  } = careinstruction;

  return (
    <div className="div-careinstructions-v2">
      <div className="div-careinstructions-content-v2">
        <div className="careinstruction-container-v2">
          {img && (
            <img
              className="careinstruction-img"
              src={img}
              alt={description || code || "Care instruction"}
            />
          )}

          {description && (
            <div className="careinstruction-description-v2">
              {description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CareInstruction;